export default async function (context) {
  context.i18n.setLocale(currentLocale(context))
}

function currentLocale(context) {
  return context.i18n.locale || 'de'
}
